import CrifAnalysisService from 'app/services/CrifAnalysisService';
import BaseAnalysisLoadPageMixin from 'app/mixins/BaseAnalysisLoadPageMixin';

export default {
  mixins: [ BaseAnalysisLoadPageMixin ],

  created() {
    this.service = CrifAnalysisService;
    this.label = 'Analisi Crif';
    this.analysisType = 'crif';
    this.findPage = 'CrifAnalyses';
    this.editorComponent = 'crif-analysis';
  },
};
